import { useNavigate } from "react-router-dom";
import MoreArrow from "../assets/MoreArrow.svg";
import styles from "./Event.module.scss";

export const Event = ({ eventImg, eventName, eventDate, eventLink }) => {
  const navigate = useNavigate();

  const handleDivClick = () => {
    navigate(eventLink);
  };

  return (
    <div className={styles.eventContainer} onClick={handleDivClick}>
      <div className={styles.eventWrapper}>
        <img
          src={eventImg}
          className={styles.eventWrapper__img}
          alt="eventImg"
        />
        <div className={styles.eventWrapper__text}>
          <p className={styles.eventWrapper__name}>{eventName}</p>
          <p className={styles.eventWrapper__date}>{eventDate}</p>
        </div>
        <div className={styles.eventOverlay}>
          <p className={styles.eventOverlay__text}>Узнать подробнее</p>
          <img
            src={MoreArrow}
            className={styles.eventOverlay__icon}
            alt="MoreArrow"
          />
        </div>
      </div>
    </div>
  );
};
